import { useState, useCallback } from "react";
import api from "../services/ApiService";

interface UseOrderModalReturn {
  modalOrderData: any;
  modalOrderOpen: boolean;
  modalOrderLoading: boolean;
  fetchAndOpenOrderModal: (orderId: number) => Promise<void>;
  closeOrderModal: () => void;
}

export function useOrderModal(): UseOrderModalReturn {
  const [modalOrderData, setModalOrderData] = useState<any>(null);
  const [modalOrderOpen, setModalOrderOpen] = useState(false);
  const [modalOrderLoading, setModalOrderLoading] = useState(false);

  const fetchAndOpenOrderModal = useCallback(async (orderId: number) => {
    setModalOrderLoading(true);
    try {
      const response = await api.getOrder(orderId);
      if (response.data) {
        setModalOrderData(response.data);
        setModalOrderOpen(true);
      }
    } catch (err) {
      console.error("[App] Failed to fetch order for modal:", err);
    } finally {
      setModalOrderLoading(false);
    }
  }, []);

  const closeOrderModal = useCallback(() => {
    setModalOrderOpen(false);
    setModalOrderData(null);
  }, []);

  return {
    modalOrderData,
    modalOrderOpen,
    modalOrderLoading,
    fetchAndOpenOrderModal,
    closeOrderModal,
  };
}
